// TODO: move to useEffect
import { SCREENS } from '@core/assistant/interfaces';

export const shared = {
  audioPlayBackType: '',
  currentRegion: '',
  visualizerInstance: null,
  // TODO: temp workaround, do a proper fix on SM side to have an option to use Transcibe only
  activeScreenGlob: SCREENS.DEFAULT,
  // TODO: temp workaround
  isMutedGlob: false,
};
